<script>
    import _                from 'lodash'
    import { onDestroy }    from 'svelte'
    import GoogleSheetsFlow from './flows/google-sheets/GoogleSheetsFlow.svelte'
    import PlaceForm        from './PlaceForm.svelte'

    export let inventory
    export let item
    export let domain
    export let errors
    export let empty

    let type  = null

    const options = [
        { id: 1 , disabled: false , experimental: false, kind: 'system'        , name: 'Sistema'              , description: 'Softwares ou sistemas de informação'           },
        { id: 2 , disabled: false , experimental: false, kind: 'real'          , name: 'Arquivo Físico/Pasta' , description: 'Arquivos físicos, pastas com arquivos, etc'    },
        { id: 3 , disabled: false , experimental: false, kind: 'shared-drive'  , name: 'Diretório na Rede'    , description: 'Diretórios de arquivos compartilhados na rede' },
        { id: 4 , disabled: false , experimental: true , kind: 'gdrive-sheets' , name: 'Google Drive'         , description: 'Planilhas no Google Drive'                     },
    ]

    onDestroy( () => {
        type = null
        item = empty()
    })

    function select(op) {
        return e => {
            type = op
            item = empty()
            item.kind = op.kind
        }
    }

</script>
    <h3 class="ui header">Escolha uma das opções abaixo</h3>
    <div class="options">
        {#each options as option}
        <div class="ui link card" class:raised={type === option}>
            <div class="content">
                {#if option.experimental}
                    <i class="ui orange right ribbon label">experimental</i>
                {/if}
                
                <div class="header">{option.name}</div>
                <!-- <div class="meta">
                    <span class="category">xxx</span>
                </div> -->
                <div class="description">
                    {option.description}
                </div>
            </div>
            <div class="extra content">
                <div class="ui right floated small button"
                        class:black={type === option} 
                        class:disabled={option.disabled}
                        on:click={select(option)}>selecionar</div>
            </div>
        </div>
        {/each}
    </div>
{#if type}
    <h4 class="ui header">{type.name}</h4>
    {#if type.kind == "gdrive-sheets"}
        <GoogleSheetsFlow bind:item {domain} {errors} {type} ></GoogleSheetsFlow>
    {:else if type}
        <PlaceForm bind:item {inventory} {errors}></PlaceForm>
    {/if}
{/if}

<style>
    .options {
        display: grid;
        grid-gap: 2em;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        padding: 1em;
    }

    .card {
        margin: 0;
    }
</style>
